<template>
  <v-list
    two-line
    flat
    :loading="loading"
    class="py-0 d-flex flex-column"
  >
    <template v-if="reminders.length">
      <div
        v-for="(reminder, index) in reminders"
        :key="reminder.value"
      >
        <v-list-item
          two-line
          class="rounded-lg px-2"
          :ripple="false"
          style="opacity: 1 !important"
          @click="reminder.expanded = !reminder.expanded"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-normal text-body-2">
              Reminder by
              <span class="font-weight-medium">{{
                reminder.createdBy.name
              }}</span>
            </v-list-item-title>
            <v-list-item-subtitle
              class="font-weight-medium text--disabled text-caption"
            >
              Triggers {{ reminder.timestamp }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider
          v-if="index !== reminders.length - 1"
          style="width: 100%"
        />
      </div>
    </template>
    <div v-else>
      <v-list-item class="pt-2">
        <v-list-item-content>
          <v-list-item-subtitle
            class="text--disabled d-flex justify-center text-caption font-weight-bold"
          >
            No reminders found.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import {
  // Firestore
  firestore,
  collection,
  getDocs,
  where,
  query,
} from "@/firebase/init";
import moment from "moment";
// Components

export default {
  name: "RemindersList",
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    reminders: [],
  }),
  mounted() {
    this.setup();
  },
  methods: {
    /* API Calls */
    // GET
    async getReminders() {
      this.reminders = [];

      if (!this.account?.id) {
        this.loading = false;
        return;
      }
      const reminders = collection(firestore, "reminders");
      const account = where("relatedID", "==", this.account.id),
        active = where("active", "==", true);

      const q = query(reminders, account, active);
      const response = await getDocs(q);

      if (!response.empty) {
        this.reminders = response.docs.map((reminder) => {
          return {
            id: reminder.id,
            active: reminder.data().active,
            ...reminder.data(),
          };
        });
      }

      this.reminders = [
        {
          createdBy: {
            name: "Ryan Trent",
          },
          timestamp: moment().add(2, "hour").fromNow(),
        },
        {
          createdBy: {
            name: "Paul Choi",
          },
          timestamp: moment().add(1, "week").subtract("1", "day").fromNow(),
        },
      ];
    },
    // POST
    /* Main */
    async setup() {
      this.loading = true;
      await this.getReminders();
      this.loading = false;
    },
    /* Misc */
  },
  computed: {
    ...mapGetters(["getAppName", "getUser"]),
  },
};
</script>

<style></style>
